import { useQuery } from '@tanstack/react-query';
import getMetadata from '../utils/getMetadata';

const useAssetMetadataQuery = (assetId, asArray = false) => {
  const metadataQuery = useQuery({
    enabled: !!assetId,
    queryKey: ['assetMetadata', assetId],
    queryFn: () => getMetadata(assetId, asArray),
    refetchOnWindowFocus: false,
    refetchInterval: Infinity,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  return metadataQuery;
};

export default useAssetMetadataQuery;
